module.exports = __webpack_public_path__ + "img/diners.bd5a9527.png";